import { useState } from "react";

import { type DatesRangeValue } from "@vericus/cadmus-ui";

import { ProjectIssuesTable } from "@/features/project-management/hooks/use-project-issues-table";
import { ColumnId } from "@/features/project-management/types";

import { DateRangeFilter } from "../../date-range-filter";

export const IssueDateRangeFilter = ({
  table,
  maxDate,
}: {
  table: ProjectIssuesTable;
  maxDate: Date;
}) => {
  const column = table.getColumn(ColumnId.DueDate);
  const [open, setOpen] = useState<boolean>(false);
  const [currentRange, setCurrentRange] = useState<DatesRangeValue>(
    (column?.getFilterValue() as DatesRangeValue) ?? [null, null]
  );

  if (!column) return null;

  const handleDateRangeChange = (dateRange: DatesRangeValue) => {
    setCurrentRange(dateRange);

    if (dateRange[0] !== null || dateRange[1] !== null) {
      column.setFilterValue(dateRange);
    } else {
      column.setFilterValue([null, null]);
    }

    setOpen(false);
  };

  return (
    <DateRangeFilter
      open={open}
      setOpen={setOpen}
      label={"Select Date"}
      maxDate={maxDate}
      selectedDateRange={currentRange}
      onDateRangeChange={handleDateRangeChange}
    />
  );
};
